"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Form = _interopRequireDefault(require("react-bootstrap/Form"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 * An Input Group used for searching content.
 *
 * FormSearch is a specialized variant of an InputGroup, with an additional
 * "clear" button to reset the search term.
 */
const FormSearch = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    defaultValue,
    hasClear,
    onChange,
    onSearchStart,
    searchType,
    value,
    ...props
  } = _ref;
  const [searchValue, setSearchValue] = (0, _react.useState)(value || defaultValue);
  const onSearchChange = e => {
    setSearchValue(e.target.value);
    if (onChange) onChange(e, e.target.value);
  };
  const clearSearch = (0, _react.useCallback)(e => {
    setSearchValue('');
    ref.current.focus();
    if (onChange) onChange(e, '');
  }, [ref]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "input-group",
    role: "search"
  }, /*#__PURE__*/_react.default.createElement(_Form.default.Control, _extends({
    "aria-label": "Search",
    onChange: onSearchChange,
    type: "text",
    value: searchValue,
    ref: ref
  }, props)), /*#__PURE__*/_react.default.createElement("div", {
    className: "input-group-append"
  }, hasClear && /*#__PURE__*/_react.default.createElement("button", {
    className: "btn btn-link",
    type: "button",
    onClick: clearSearch
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "sr-only"
  }, "Clear"), /*#__PURE__*/_react.default.createElement("span", {
    className: "icon-answer-incorrect-boulder",
    "aria-hidden": "true",
    title: "Clear"
  })), searchType === 'dynamic' && /*#__PURE__*/_react.default.createElement("button", {
    className: "input-group-text",
    id: "search-clear-addon",
    onClick: onSearchStart,
    type: "button",
    disabled: value === '' && defaultValue !== ''
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "sr-only"
  }, "Search"), /*#__PURE__*/_react.default.createElement("span", {
    className: "icon-search-boulder",
    "aria-hidden": "true",
    title: "Search"
  })), searchType === 'explicit' && /*#__PURE__*/_react.default.createElement("button", {
    className: "btn btn-primary" // on consumer should be btn-link
    ,
    type: "submit",
    id: "search-active-addon",
    disabled: value === '' && defaultValue !== '',
    onClick: onSearchStart
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "sr-only"
  }, "Search"), /*#__PURE__*/_react.default.createElement("span", {
    className: "icon-search",
    "aria-hidden": "true",
    title: "Search"
  }))));
});
FormSearch.displayName = 'FormSearch';
FormSearch.propTypes = {
  /**
   * The default value of the input; this is overridden by the `value` prop when set
   */
  defaultValue: _propTypes.default.string,
  /**
   * Adds the clear button inside the text field
   */
  hasClear: _propTypes.default.bool,
  /**
   * The `ID` for the input & `htmlFor` the label
   */
  id: _propTypes.default.string.isRequired,
  /**
   * The change event handler
   */
  onChange: _propTypes.default.func,
  /**
   * The click handler for when a person starts a search.  It is recommended that you clear the search input with this callback.
   */
  onSearchStart: _propTypes.default.func,
  /**
   * Specifies type of search input
   */
  searchType: _propTypes.default.oneOf(['dynamic', 'explicit']).isRequired,
  /**
   * The value of the input; this overrides `defaultValue` when set
   */
  value: _propTypes.default.string
};
FormSearch.defaultProps = {
  hasClear: false,
  searchType: 'dynamic'
};
var _default = exports.default = FormSearch;